var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"layout"}},[_c('main',{staticStyle:{"overflow":"hidden"}},[_c('menu-bar'),_c('app-content')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }